import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/src/app/[locale]/error.tsx");
